import { Component, Input } from '@angular/core';
import {
  MatCard,
  MatCardContent,
  MatCardImage,
  MatCardSubtitle,
} from '@angular/material/card';
import { MatIcon } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-tile',
  imports: [
    MatCard,
    MatCardContent,
    MatCardSubtitle,
    MatIcon,
    MatCardImage,
    RouterLink,
    TranslatePipe,
  ],
  templateUrl: './tile.component.html',
  styleUrl: './tile.component.scss',
  standalone: true,
})
export class TileComponent {
  @Input() title: string;
  @Input() iconName: string;
  @Input() imageName: string;
  @Input() link!: string;
  @Input() ariaLabel: string;
  @Input() variant: 'default' | 'together' = 'default';

  get imagePath(): string {
    return `assets/img/${this.imageName}`;
  }

  get isTogetherVariant(): boolean {
    return this.variant === 'together';
  }
}
